import "./ForgotPassword.css";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import Auth from "../Auth/Auth";
import * as links from "../../../utils/links";
import signin from "../../../assets/images/teste_azul1.png";
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

const initialDataSignIn = {
  email: "",
  password: "",
};

const initErrorField = {
  email: undefined,
  password: undefined,
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const ForgotPassword = (props) => {
  const { setDataUser, loading, notiMessage, setNotiMessage } =
    useContext(AuthContext);
  let navigate = useNavigate();

  // useEffect(() => {
  //     if (notiMessage) {
  //         setNotiMessage(null)
  //         NotificationManager.error(notiMessage, 'Hmm... ');
  //     }
  // }, [])

  const [dataAuth, setDataSingUp] = useState({ ...initialDataSignIn });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [errorField, setErrorField] = useState({ ...initErrorField });
  const [isLoading, setIsLoading] = useState(false);

  const onsubmit = () => {
    let dataErrorField = {};
    if (dataAuth.email.trim() === "") {
      dataErrorField = {
        ...dataErrorField,
        email: "Email obrigatório.",
      };
    } else if (!validateEmail(dataAuth.email.trim())) {
      dataErrorField = {
        ...dataErrorField,
        email: "Email inválido.",
      };
    }

    setSuccess(false);
    if (Object.keys(dataErrorField).length === 0) {
      setIsLoading(true);
      setError(null);
      axios
        .post(`${process.env.REACT_APP_SERVIDOR}/forgot-password`, {
          email: dataAuth.email.trim(),
        })
        .then((res) => {
          if (res.status === 200) {
            setNotiMessage({
              type: 'success',
              message: 'Email enviado com sucesso! Verifique sua caixa de email para recuperar a senha'
            })
            setIsLoading(false);
            setSuccess(true);
          } else {
            throw new Error();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          // setNotiMessage({
          //     type: 'error',
          //     message: 'Desculpe aconteceu algum problema, não foi possível inserir o crédito remotamente'
          // })
          if (err.response.status === 500) {
            setError(
              'Usuário já existe, <a target="_blank" href=' +
              links.FORGOTPASSWORD +
              ">esqueceu sua senha<a/>?"
            );
          } else {
            setError(
              "Erro, algo deu errado " + (err.response?.data?.error ?? "")
            );
          }
        });
    } else {
      setErrorField((prev) => {
        return {
          ...prev,
          ...dataErrorField,
        };
      });
    }
  };

  return (
    <>
      <NotificationContainer />
      {isLoading && <LoadingAction />}
      {success ?
        <Auth
          authTitle={"Email enviado com sucesso"}
          authDescription={"Vá até sua caixa de email e clique no link para redefinir sua senha"}
          authFields={[]}
          authSubmit={"Ir para tela de login"}
          textImage={"IK Pay systema"}
          authImage={signin}
          onsubmit={() => {
            window.history.back()
          }}
          forgot_password={false}
          errorMessage={error ?? ""}
          isSignIn={true}
        />
        :
        <Auth
          authTitle={"Recupere a Senha"}
          authDescription={"Preencha com e-mail cadastrado"}
          authFields={[
            {
              label: "E-mail",
              placeholder: "Digite seu e-mail",
              name: "email",
              value: dataAuth?.email ?? "",
              type: "text",
              setField: (value) => {
                setDataSingUp((prev) => ({
                  ...prev,
                  email: value,
                }));
                setErrorField((prev) => ({
                  ...prev,
                  email: undefined,
                }));
              },
              error: errorField?.email ?? "",
            }
          ]}
          forgot_password={false}
          authSubmit={"Enviar Email"}
          textImage={"IK Pay systema"}
          authImage={signin}
          login={true}
          onsubmit={() => {
            onsubmit();
          }}
          successMessage={success ? "Usuário cadastrado com sucesso!" : ""}
          errorMessage={error ?? ""}
          isSignIn={true}
        />
      }

    </>
  );
};

export default ForgotPassword;
